import { type ReactNode } from "react";

import { type TosMetadata } from "../../../gql-generated/types";
import { parseStringWithBrAndNewLines } from "../../utils/parse";

import { TOS_HEADER_MAP } from "./constants";

export interface TosStepData {
    content: ReactNode;
    sourceUrl?: string;
    key?: string;
    effectiveDate?: string;
}

export const getTosStepData = (terms: TosMetadata["terms"], currentStep: number): TosStepData | null => {
    if (terms.length === 0) return null;

    const term = terms[currentStep];
    if (!term) return null;

    return {
        content: parseStringWithBrAndNewLines(term.content || ""),
        sourceUrl: term.sourceUrl,
        key: term.key,
        effectiveDate: term.effectiveDate,
    };
};

export const getTosHeaderText = (key?: string): ReactNode => {
    if (!key) return "";
    if (key in TOS_HEADER_MAP) {
        return TOS_HEADER_MAP[key as keyof typeof TOS_HEADER_MAP];
    }
    return "";
};
